/**
 * JSU Global Theme - Main JavaScript
 * 
 * @package JSU_Global
 */

(function($) {
    'use strict';
    
    $(document).ready(function() {
        initMobileMenu();
        initSearch();
    });
    
    function initMobileMenu() {
        const $menuToggle = $('<button class="menu-toggle">Menu</button>');
        const $navigation = $('#site-navigation');
        
        $navigation.before($menuToggle);
        
        $menuToggle.on('click', function() {
            $navigation.toggleClass('open');
        });
    }
    
    function initSearch() {
        // Add search functionality if needed
    }
    
})(jQuery);
